module.exports = __webpack_public_path__ + "static/calendar-41796df81a6e55fc4582bf628e7c55af.png";